import { ConfigurationState } from './types'

export const initialState: ConfigurationState = {}
